// Mock data for Sauce Dogz website

export const signatureHotDogs = [
  {
    id: 1,
    name: "Solar Flare",
    description: "Spicy chili • nacho cheese • sriracha",
    price: "$6",
    icon: "flame",
    popular: false
  },
  {
    id: 2,
    name: "Green Comet",
    description: "Avocado crema • pico de gallo • cotija • cilantro",
    price: "$6",
    icon: "leaf",
    popular: false
  },
  {
    id: 3,
    name: "Lunar Aioli",
    description: "Garlic aioli • caramelized onions • cream cheese • chives",
    price: "$6",
    icon: "moon",
    popular: false
  },
  {
    id: 4,
    name: "Stardust BBQ",
    description: "Spicy BBQ • pickled red cabbage • crispy onions • jalapeños",
    price: "$6",
    icon: "star",
    popular: false
  }
];

export const sidesAndDrinks = [
  {
    id: 11,
    category: "Sides",
    name: "Chips",
    price: "$1.50"
  },
  {
    id: 12,
    category: "Drinks",
    name: "Soda",
    price: "$1.50"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus T.",
    rating: 5,
    text: "Best hot dogs in the city! The Galaxy Gourmet is out of this world.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Sarah K.",
    rating: 5,
    text: "Love the astronaut theme and the dogs are fire! The Meteor Melt is my go-to.",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jamie L.",
    rating: 5,
    text: "Creative menu and amazing flavors. A must-try for any hot dog lover!",
    date: "3 weeks ago"
  }
];

export const locationInfo = {
  address: "Surprise, AZ",
  hours: [
    { day: "Saturday", time: "10:30 AM - 3:00 PM" },
    { day: "Sunday", time: "10:30 AM - 3:00 PM" }
  ],
  phone: "(602) 730-4994",
  email: "saucedogz@yahoo.com",
  established: "Est. 2025"
};

// Mock function to simulate contact form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      submissions.push({ ...formData, timestamp: new Date().toISOString() });
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};